//region header
//--------------------------------------------------------------------------------------------------
//
//  Description: OK Cancel component
//
//  Copyright:   © 2021 - 2025 Idox Software Limited.
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier             Issue# Description
//region Version 1.0.0.0
//    001   02.07.21 Sean Flook                  Initial Revision.
//    002   06.10.23 Sean Flook                  Use colour variables.
//endregion Version 1.0.0.0
//region Version 1.0.5.0
//    003   27.01.25 Sean Flook       IMANN-1077 Upgraded MUI to v6.
//endregion Version 1.0.5.0
//region Version 1.0.7.0
//    004   13.06.25 Sean Flook       IMANN-1812 Moved defaults.
//    005   28.08.25 Sean Flook       IMANN-1812 Changes required to update MUI to v7.
//    006   28.10.25 Sean Flook       IMANN-2112 Changed to display the buttons in their own container.
//endregion Version 1.0.7.0
//
//--------------------------------------------------------------------------------------------------
//endregion header

import React from "react";
import PropTypes from "prop-types";
import { Button, Box } from "@mui/material";
import { Check as CheckIcon, Close as CloseIcon } from "@mui/icons-material";
import { adsBlueA, adsLightBlue10, adsOffWhite } from "../utils/ADSColours";
import { okCancelControlHeight } from "../utils/ADSStyles";
import { Stack } from "@mui/system";

ADSOkCancelControl.propTypes = {
  okLabel: PropTypes.string.isRequired,
  cancelLabel: PropTypes.string.isRequired,
  okDisabled: PropTypes.bool.isRequired,
  cancelDisabled: PropTypes.bool.isRequired,
  indented: PropTypes.bool,
  onOkClicked: PropTypes.func.isRequired,
  onCancelClicked: PropTypes.func.isRequired,
};

function ADSOkCancelControl({
  okLabel = "OK",
  cancelLabel = "Cancel",
  okDisabled = false,
  cancelDisabled = false,
  onOkClicked,
  onCancelClicked,
}) {
  /**
   * Event to handle when the OK button is clicked.
   */
  const handleOkClicked = () => {
    if (onOkClicked) onOkClicked();
  };

  /**
   * Event to handle when the cancel button is clicked.
   */
  const handleCancelClicked = () => {
    if (onCancelClicked) onCancelClicked();
  };

  return (
    <Box
      sx={{
        height: `${okCancelControlHeight}px`,
        backgroundColor: adsOffWhite,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      <Stack direction="row" spacing={2} justifyContent={"flex-end"} alignItems="center" sx={{ mr: "12px" }}>
        <Button
          id={`${okLabel.toLowerCase().replaceAll(" ", "-")}-button`}
          sx={{ mt: "6px" }}
          variant="contained"
          color="primary"
          startIcon={<CheckIcon />}
          disabled={okDisabled}
          onClick={handleOkClicked}
        >
          {okLabel}
        </Button>
        <Button
          id={`${cancelLabel.toLowerCase().replaceAll(" ", "-")}-button`}
          sx={{
            mt: "6px",
            color: adsBlueA,
            "&:hover": {
              backgroundColor: adsLightBlue10,
            },
          }}
          variant="text"
          startIcon={<CloseIcon />}
          disabled={cancelDisabled}
          onClick={handleCancelClicked}
        >
          {cancelLabel}
        </Button>
      </Stack>
    </Box>
  );
}

export default ADSOkCancelControl;
